export default __webpack_public_path__ + "d1a99a8e95955b0287d2ed6f0092e329.svg";